export default {"src":"/_next/static/media/CNH.1d61dd9d.svg","height":339,"width":512,"blurWidth":0,"blurHeight":0};